
export class FileProcessingService {
  static async compressAndConvertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      console.log('🔧 FileProcessingService: Starting compression for file:', file.name, file.size);
      
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      
      img.onload = () => {
        try {
          console.log('🔧 FileProcessingService: Image loaded, original dimensions:', img.width, 'x', img.height);
          
          // Calculate new dimensions while maintaining aspect ratio
          const maxDimension = 800;
          let { width, height } = img;
          
          if (width > maxDimension || height > maxDimension) {
            if (width > height) {
              height = (height * maxDimension) / width;
              width = maxDimension;
            } else {
              width = (width * maxDimension) / height;
              height = maxDimension;
            }
          }
          
          console.log('🔧 FileProcessingService: Resized dimensions:', width, 'x', height);
          
          // Set canvas dimensions
          canvas.width = width;
          canvas.height = height;
          
          // Clear canvas and draw resized image
          if (ctx) {
            ctx.clearRect(0, 0, width, height);
            ctx.drawImage(img, 0, 0, width, height);
            
            // Convert to base64 with quality compression
            const quality = 0.8; // 80% quality
            const base64String = canvas.toDataURL('image/jpeg', quality);
            
            console.log('🔧 FileProcessingService: Conversion complete');
            console.log('🔧 FileProcessingService: Base64 length:', base64String.length);
            console.log('🔧 FileProcessingService: Base64 prefix:', base64String.substring(0, 50));
            
            // CRITICAL FIX: Ensure the base64 string is properly formatted
            if (base64String.startsWith('data:image/')) {
              resolve(base64String);
            } else {
              console.error('🔧 FileProcessingService: Invalid base64 format generated');
              reject(new Error('Failed to generate valid base64 format'));
            }
          } else {
            reject(new Error('Failed to get canvas context'));
          }
        } catch (error) {
          console.error('🔧 FileProcessingService: Error during compression:', error);
          reject(error);
        }
      };
      
      img.onerror = () => {
        console.error('🔧 FileProcessingService: Failed to load image for compression');
        reject(new Error('Failed to load image for compression'));
      };
      
      // Create object URL and load image
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;
      
      // Clean up object URL after image loads or errors
      const cleanup = () => {
        URL.revokeObjectURL(objectUrl);
      };
      
      img.onload = () => {
        cleanup();
        // Call the original onload logic
        try {
          console.log('🔧 FileProcessingService: Image loaded, original dimensions:', img.width, 'x', img.height);
          
          // Calculate new dimensions while maintaining aspect ratio
          const maxDimension = 800;
          let { width, height } = img;
          
          if (width > maxDimension || height > maxDimension) {
            if (width > height) {
              height = (height * maxDimension) / width;
              width = maxDimension;
            } else {
              width = (width * maxDimension) / height;
              height = maxDimension;
            }
          }
          
          console.log('🔧 FileProcessingService: Resized dimensions:', width, 'x', height);
          
          // Set canvas dimensions
          canvas.width = width;
          canvas.height = height;
          
          // Clear canvas and draw resized image
          if (ctx) {
            ctx.clearRect(0, 0, width, height);
            ctx.drawImage(img, 0, 0, width, height);
            
            // Convert to base64 with quality compression
            const quality = 0.8; // 80% quality
            const base64String = canvas.toDataURL('image/jpeg', quality);
            
            console.log('🔧 FileProcessingService: Conversion complete');
            console.log('🔧 FileProcessingService: Base64 length:', base64String.length);
            console.log('🔧 FileProcessingService: Base64 prefix:', base64String.substring(0, 50));
            
            // CRITICAL FIX: Ensure the base64 string is properly formatted
            if (base64String.startsWith('data:image/')) {
              resolve(base64String);
            } else {
              console.error('🔧 FileProcessingService: Invalid base64 format generated');
              reject(new Error('Failed to generate valid base64 format'));
            }
          } else {
            reject(new Error('Failed to get canvas context'));
          }
        } catch (error) {
          console.error('🔧 FileProcessingService: Error during compression:', error);
          reject(error);
        }
      };
      
      img.onerror = () => {
        cleanup();
        console.error('🔧 FileProcessingService: Failed to load image for compression');
        reject(new Error('Failed to load image for compression'));
      };
    });
  }

  static validateFileType(file: File, allowedTypes: string[]): boolean {
    console.log('🔧 FileProcessingService: Validating file type:', file.type, 'against:', allowedTypes);
    
    return allowedTypes.some(type => {
      if (type.startsWith('.')) {
        // Extension check
        return file.name.toLowerCase().endsWith(type.toLowerCase());
      } else if (type.endsWith('/')) {
        // MIME type prefix check (e.g., 'image/')
        return file.type.startsWith(type);
      } else {
        // Exact MIME type check
        return file.type === type;
      }
    });
  }

  static async processDocumentFile(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      console.log('🔧 FileProcessingService: Processing document file:', file.name);
      
      const reader = new FileReader();
      
      reader.onload = (e) => {
        try {
          const content = e.target?.result as string;
          console.log('🔧 FileProcessingService: Document processed, length:', content.length);
          resolve(content);
        } catch (error) {
          console.error('🔧 FileProcessingService: Error processing document:', error);
          reject(error);
        }
      };
      
      reader.onerror = () => {
        console.error('🔧 FileProcessingService: Failed to read document file');
        reject(new Error('Failed to read document file'));
      };
      
      reader.readAsText(file);
    });
  }
}
